import React from "react";
import { Tooltip } from "antd";
import moment from "moment";
import { AiOutlineStar } from "react-icons/ai";
function SupplyingTableIndex({
  item,
  id_order_row,
  product_reference,
  children = false,
}) {
  return (
    <tr className="text-xs" style={{
      // fontSize: "0.75rem",
      borderLeft: `1px solid ${item.used_at ? '#03b0f7' : 'transprent'}`
    }}>
      <td className="d-flex" style={{ fontSize: "0.75rem" }}>
        {children}
        {item.amount ?? 0}
        {"* "}
      </td>
      <td style={{ fontSize: "0.75rem" }}>
        {item.spec_order && (
          <Tooltip
            className="text-primary mr-1 text-xl"
            placement="top"
            title={"SPEC order"}
          >
            *
          </Tooltip>
        )}
        {item.supplier_code ||
          product_reference ||
          item.product_code ||
          id_order_row}
      </td>
      <td style={{ fontSize: "0.75rem" }}>
        <div className="d-flex align-items-center">
          {item.guaranteed_delivery && (
            <Tooltip placement="top" title={"Guaranteed delivery"}>
              <AiOutlineStar className="text-orange text-xs mr-2" />
            </Tooltip>
          )}

          {item.supplier
            ? item.supplier.name
            : item.presta_service
              ? `${item.presta_service.service_center} - ${item.presta_service.address}`
              : ""}
        </div>
      </td>
      <td style={{ fontSize: "0.75rem" }} colSpan={3}>
        {item.date}
      </td>
      <td style={{ fontSize: "0.75rem" }} colSpan={1}>
        <Tooltip
          placement="top"
          title={<div>
            <div>
              Created: {moment(item.created_at).format("YYYY-MM-DD HH:mm")}
            </div>
            {item.used_at && (
              <div>
                Used: {moment(item.used_at).format("YYYY-MM-DD HH:mm")}
              </div>
            )}
          </div>}
        >
          {item.user_title}
        </Tooltip>
      </td>
    </tr>
  );
}

export default SupplyingTableIndex;
